"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SKAD_EXCHANGE_DIGIT_LABELS = exports.SKAD_DOW_DIGIT_LABELS = exports.MODEL_IGNORED_LABELS = exports.COARSE_CONVERSION_NUMBER_LABELS = exports.CREATIVE_TYPE_LABELS = exports.SKAN_FIDELITY_LABELS = void 0;
exports.SKAN_FIDELITY_LABELS = {
    "-1": "null",
    "0": "view-through",
    "1": "click-through",
};
exports.CREATIVE_TYPE_LABELS = {
    rich_media: "Rich Media",
    R: "Rich Media",
    V: "Vast Video",
    "VAST 2.0": "Vast Video",
    N: "Native",
};
exports.COARSE_CONVERSION_NUMBER_LABELS = {
    "": "null/unknown",
    "0": "null/unknown",
    "1": "Low",
    "2": "Medium",
    "3": "High",
};
exports.MODEL_IGNORED_LABELS = {
    "-1": "null/unknown",
    "0": "Model used",
    "1": "Model not used",
};
const withDigitLabel = (map) => Object.entries(map)
    .map(([key, value]) => [key, `${value} (${key})`])
    .reduce((obj, [key, value]) => {
    obj[key] = value;
    return obj;
}, {});
const SKAD_DOW_DIGIT_MAP = {
    "1": "Monday",
    "2": "Tuesday",
    "3": "Wednesday",
    "4": "Thursday",
    "5": "Friday",
    "6": "Saturday",
    "7": "Sunday",
};
const SKAD_EXCHANGE_DIGIT_MAP = {
    "1": "applovin",
    "2": "chartboost",
    "3": "mintegral",
    "4": "verve",
    "5": "ironsource",
    "6": "smaato",
    "7": "unity",
    "8": "vungle",
    "9": "fyber",
};
exports.SKAD_DOW_DIGIT_LABELS = withDigitLabel(SKAD_DOW_DIGIT_MAP);
exports.SKAD_EXCHANGE_DIGIT_LABELS = withDigitLabel(SKAD_EXCHANGE_DIGIT_MAP);
